<template>
  <Day day="01.12.2025">
    <div slot="page-content">
      <h3>The Key to our Home 👷‍♀️</h3>
      <p>
        <img src="@/assets/day1.jpeg"/>
      </p>
    </div>
  </Day>
</template>

<script>
import Day from '../Day.vue'

export default {
  name: 'Day01',
  components: {
    Day
  }
}
</script>
